import TextAreaField from './component'

export default TextAreaField
